import { useRef, useState } from "react";
import Warnings from "../Warnings/Warnings";

import styles from "./Setup.module.css";

const Setup = ({ list, setList, setTeams, setShowSetup, setNumberOfTeams }) => {
  const [listInput, setListInput] = useState("");
  const [number, setNumber] = useState("");

  const inputRef = useRef();

  const isDev = process.env.NODE_ENV === "development";

  const handleClick = (e) => {
    e.preventDefault();
    setList([...list, listInput]);
    setListInput("");
    inputRef.current.focus();
  };

  const handleChange = (event) => {
    setNumber(event.target.value);
  };

  const handleContinue = () => {
    if (list.length < number) {
      return;
    }

    setTeams(Array.from(Array(parseInt(number)), () => []));
    setNumberOfTeams(number);
    setShowSetup(false);
  };

  const populate = () => {
    if (!isDev) {
      return;
    }

    setList([
      "Name 1",
      "Name 2",
      "Name 3",
      "Name 4",
      "Name 5",
      "Name 6",
      "Name 7",
      "Name 8",
      "Name 9",
      "Name 10",
      "Name 11",
      "Name 12",
    ]);
    setNumber(3);
  };

  return (
    <div>
      <form className={styles.form}>
        <input
          className={styles.nameInput}
          ref={inputRef}
          value={listInput}
          onChange={(e) => setListInput(e.target.value)}
          placeholder="Add a name"
        />
        <button
          className={styles.addButton}
          disabled={listInput.length < 1 ? true : false}
          type="submit"
          onClick={handleClick}
        >
          +
        </button>
      </form>
      {isDev && (
        <button style={{ marginBottom: "2rem" }} onClick={populate}>
          populate
        </button>
      )}
      <div className={styles.continue}>
        <input
          onChange={handleChange}
          value={number}
          min={1}
          placeholder="Team size"
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
        />
        <button
          disabled={list.length < number || list.length === 0}
          onClick={handleContinue}
        >
          Continue
        </button>
      </div>
      <Warnings listLength={list.length} number={number} />
    </div>
  );
};

export default Setup;
